/**
 * Case-insensitive, TLD-length-agnostic email format check.
 * Shared across coach create/edit, update-email dialog, and onboarding.
 */
export const EMAIL_FORMAT_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

/** Returns true when `v` is a non-empty string matching EMAIL_FORMAT_REGEX. */
export function isValidEmailFormat(v: string | undefined | null): boolean {
  return !!v && EMAIL_FORMAT_REGEX.test(v);
}
